import EID from '@/views/EID.vue';
import EIDIntro from '@/views/EIDIntro.vue';
import SigningPage from '@/pages/SigningPage.vue';
import ESignaturePage from '@/pages/ESignaturePage.vue';

export default [
  /*
  * EID
  * */
  {
    name: 'EIDIntro',
    path: '/e-podpis',
    component: EIDIntro,
    meta: {
      pathEN: '/e-signature',
      pathUA: '/elektronnayi-pidpys',
      pathRU: '/e-podpis\'',
      step: 22,
      ga: {
        virtualPagePath: '/uzp/10_epodpis',
        virtualPageTitle: 'Prihláška do ZP - epodpis',
      },
      routeStepType: 'COMMON',
    },
  },
  {
    name: 'EID',
    path: '/e-podpis-podpisovac',
    component: EID,
    meta: {
      pathEN: '/e-signature-dsigner',
      pathUA: '/elektronnayi-pidpys-dsigner',
      pathRU: '/e-podpis\'-podpisyvayushchiy',
      step: 22,
      ga: {
        virtualPagePath: '/uzp/11_epodpis_podpisovac',
        virtualPageTitle: 'Prihláška do ZP - epodpis podpisovač',
      },
      routeStepType: 'COMMON',
    },
  },
  /*
  * CGI eSignature
  * */
  {
    name: 'SignUpdate',
    path: '/uprava-sposobu-podpisu-prihlasky',
    component: SigningPage,
    meta: {
      pathEN: '/update-delivery-and-signature',
      pathUA: '/update-dostavka-ta-pidpys',
      pathRU: '/nastroyka-metoda-podpisi-zayavkis',
      step: 22,
      ga: {
        virtualPagePath: '/uzp/7_dorucenie-a-podpis-prihlasky',
        virtualPageTitle: 'Prihláška do ZP - Doručenie a podpis prihlášky',
      },
      routeStepType: 'COMMON',
    },
  },
  {
    name: 'ESignature',
    path: '/digitalny-podpis',
    component: ESignaturePage,
    meta: {
      pathEN: '/digital-signature',
      pathUA: '/tsyfrovyy-pidpys',
      pathRU: '/tsifrovaya-podpis\'',
      step: 22,
      ga: {
        virtualPagePath: '/uzp/10_esign',
        virtualPageTitle: 'Prihláška do ZP - esign',
      },
      routeStepType: 'COMMON',
    },
  },
];
